unit View.Modulos_Acesso.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils, UConstantes, UPersonalizacao_Tabela.Interfaces,
  UPersonalizacao_Tabela, System.StrUtils, UHelperServer;

type
  TFViewModulos_AcessoList = class(TForm)
    Modulos_AcessoDataset: TXDataWebDataSet;
    Modulos_AcessoDatasetmodulo: TStringField;
    Modulos_AcessoDatasetultimo_acesso: TDateTimeField;
    Modulos_AcessoDatasetinclusao: TDateTimeField;
    Modulos_AcessoDatasetalteracao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    btnExportarExcel: TButton;
    Modulos_AcessoDatasetfuncionarionome: TXDataWebDatasetField;
    edtCidadeNome: TEdit;
    btnPesquisarCidade: TButton;
    edtSegmentoNome: TEdit;
    btnPesquisarSegmento: TButton;
    edtParceiroNome: TEdit;
    btnPesquisarParceiro: TButton;
    Modulos_AcessoDatasetaliadoNome_Fantasia: TStringField;
    Modulos_AcessoDatasetfuncionariocodigo_interno: TIntegerField;
    Modulos_AcessoDatasetaliadosegmentoNome: TStringField;
    Modulos_AcessoDatasetaliadoCNPJ: TStringField;
    Modulos_AcessoDatasetaliadocidadeNome: TStringField;
    Modulos_AcessoDatasetaliadocidadeufSigla: TStringField;
    Modulos_AcessoDatasetaliadoparceironome: TStringField;
    Modulos_AcessoDatasetdbpath: TStringField;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure btnExportarExcelClick(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    [async]
    procedure btnPesquisarCidadeClick(Sender: TObject); async;
    [async]
    procedure btnPesquisarSegmentoClick(Sender: TObject); async;
    [async]
    procedure btnPesquisarParceiroClick(Sender: TObject); async;
    procedure Modulos_AcessoDatasetaliadoNome_FantasiaGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure Modulos_AcessoDatasetaliadosegmentoNomeGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure Modulos_AcessoDatasetaliadoCNPJGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure Modulos_AcessoDatasetaliadocidadeNomeGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

    function GetFiltro : string;
    procedure Filtrar;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewModulos_AcessoList: TFViewModulos_AcessoList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewModulos_AcessoList }

procedure TFViewModulos_AcessoList.btnExportarExcelClick(Sender: TObject);
begin
  TUtils.ExportarDadosExcel(Modulos_AcessoDataset, WebDBTableControl1,
    FGridPlugin.FDatasetPlugin.FDataset.QueryString, FGridPlugin.FQuantidadeRegistrosBusca);
end;

procedure TFViewModulos_AcessoList.btnPesquisarCidadeClick(Sender: TObject);
var
  lBackupTag : Integer;
begin
  lBackupTag := edtCidadeNome.Tag;
  Await(THelperServer.ChamarConsulta('Cidades', 'Cidade', edtCidadeNome));

  if lBackupTag <> edtCidadeNome.Tag then
    Filtrar;
end;

procedure TFViewModulos_AcessoList.btnPesquisarParceiroClick(Sender: TObject);
var
  lBackupTag : Integer;
begin
  lBackupTag := edtParceiroNome.Tag;
  Await(THelperServer.ChamarConsulta('Parceiros', 'Parceiros', edtParceiroNome));

  if lBackupTag <> edtParceiroNome.Tag then
    Filtrar;
end;

procedure TFViewModulos_AcessoList.btnPesquisarSegmentoClick(Sender: TObject);
var
  lBackupTag : Integer;
begin
  lBackupTag := edtSegmentoNome.Tag;
  Await(THelperServer.ChamarConsulta('Segmentos', 'Segmentos', edtSegmentoNome));

  if lBackupTag <> edtSegmentoNome.Tag then
    Filtrar;
end;

procedure TFViewModulos_AcessoList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewModulos_AcessoList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewModulos_AcessoList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewModulos_AcessoList, AElementID, Result, @AfterCreate);
end;

procedure TFViewModulos_AcessoList.edSearchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewModulos_AcessoList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewModulos_AcessoList.Filtrar;
begin
  FGridPlugin.FDatasetPlugin.FFilterPadrao := Trim(GetFiltro);
  FGridPlugin.Load;
end;

function TFViewModulos_AcessoList.GetFiltro: string;
var
  lListaFiltro : TStringList;
begin
  Result := EmptyStr;

  lListaFiltro := TStringList.Create;

  try
    if edtCidadeNome.Tag <> 0 then
      lListaFiltro.Add('(aliado.cidade_id eq '+edtCidadeNome.Tag.ToString+')');

    if edtSegmentoNome.Tag <> 0 then
      lListaFiltro.Add('(aliado.segmento_id eq '+edtSegmentoNome.Tag.ToString+')');

    if edtParceiroNome.Tag <> 0 then
      lListaFiltro.Add('(aliado.parceiro_id eq '+edtParceiroNome.Tag.ToString+')');

    if lListaFiltro.Count > 0 then
      Result := string.Join(' and ', lListaFiltro.ToStringArray);
  finally
    if Assigned(lListaFiltro) then
      FreeAndNil(lListaFiltro)
  end;
end;

procedure TFViewModulos_AcessoList.Modulos_AcessoDatasetaliadocidadeNomeGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCidadeEstado(Sender.AsString, Modulos_AcessoDataset.FieldByName('aliado.cidade.uf.Sigla').AsString);
end;

procedure TFViewModulos_AcessoList.Modulos_AcessoDatasetaliadoCNPJGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCnpj_Cpf(Sender.AsString);
end;

procedure TFViewModulos_AcessoList.Modulos_AcessoDatasetaliadoNome_FantasiaGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := Sender.AsString.ToUpper;
end;

procedure TFViewModulos_AcessoList.Modulos_AcessoDatasetaliadosegmentoNomeGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := Sender.AsString.ToUpper;
end;

procedure TFViewModulos_AcessoList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewModulos_AcessoList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Modulos_AcessoDataset.Connection.Model.DefaultSchema.FindEntityType(Modulos_AcessoDataset.EntitySetName),
      Modulos_AcessoDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewModulos_AcessoList.WebDBTableControl1GetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['aliado.Nome_Fantasia', 'modulo',
      'funcionario.nome', 'aliado.CNPJ', 'aliado.segmento.Nome', 'aliado.cidade.Nome',
      'aliado.parceiro.nome', 'db.path']) of
      0, 1, 2, 3, 4, 5, 6, 7: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewModulos_AcessoList.WebDBTableControl1GetCellData(
  Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
    AValue := AValue.ToUpper;
end;

procedure TFViewModulos_AcessoList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('modulos_acesso', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, Modulos_AcessoDataset, lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'inclusao desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewModulos_AcessoList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.modulos_acesso.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.modulos_acesso.list.table');
  cbPageSize := TComboBox.Create('view.modulos_acesso.list.cbPageSize');
  edSearch := TEdit.Create('view.modulos_acesso.list.search');
  lcPaginator := TListControl.Create('view.modulos_acesso.list.pagination');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  edtCidadeNome := TEdit.Create('edtCidadeNome');
  btnPesquisarCidade := TButton.Create('btnPesquisarCidade');
  edtSegmentoNome := TEdit.Create('edtSegmentoNome');
  btnPesquisarSegmento := TButton.Create('btnPesquisarSegmento');
  edtParceiroNome := TEdit.Create('edtParceiroNome');
  btnPesquisarParceiro := TButton.Create('btnPesquisarParceiro');
  Modulos_AcessoDataset := TXDataWebDataSet.Create(Self);
  Modulos_AcessoDatasetaliadoNome_Fantasia := TStringField.Create(Self);
  Modulos_AcessoDatasetaliadoCNPJ := TStringField.Create(Self);
  Modulos_AcessoDatasetmodulo := TStringField.Create(Self);
  Modulos_AcessoDatasetultimo_acesso := TDateTimeField.Create(Self);
  Modulos_AcessoDatasetfuncionariocodigo_interno := TIntegerField.Create(Self);
  Modulos_AcessoDatasetfuncionarionome := TXDataWebDatasetField.Create(Self);
  Modulos_AcessoDatasetaliadosegmentoNome := TStringField.Create(Self);
  Modulos_AcessoDatasetaliadocidadeNome := TStringField.Create(Self);
  Modulos_AcessoDatasetaliadocidadeufSigla := TStringField.Create(Self);
  Modulos_AcessoDatasetaliadoparceironome := TStringField.Create(Self);
  Modulos_AcessoDatasetdbpath := TStringField.Create(Self);
  Modulos_AcessoDatasetinclusao := TDateTimeField.Create(Self);
  Modulos_AcessoDatasetalteracao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  edtCidadeNome.BeforeLoadDFMValues;
  btnPesquisarCidade.BeforeLoadDFMValues;
  edtSegmentoNome.BeforeLoadDFMValues;
  btnPesquisarSegmento.BeforeLoadDFMValues;
  edtParceiroNome.BeforeLoadDFMValues;
  btnPesquisarParceiro.BeforeLoadDFMValues;
  Modulos_AcessoDataset.BeforeLoadDFMValues;
  Modulos_AcessoDatasetaliadoNome_Fantasia.BeforeLoadDFMValues;
  Modulos_AcessoDatasetaliadoCNPJ.BeforeLoadDFMValues;
  Modulos_AcessoDatasetmodulo.BeforeLoadDFMValues;
  Modulos_AcessoDatasetultimo_acesso.BeforeLoadDFMValues;
  Modulos_AcessoDatasetfuncionariocodigo_interno.BeforeLoadDFMValues;
  Modulos_AcessoDatasetfuncionarionome.BeforeLoadDFMValues;
  Modulos_AcessoDatasetaliadosegmentoNome.BeforeLoadDFMValues;
  Modulos_AcessoDatasetaliadocidadeNome.BeforeLoadDFMValues;
  Modulos_AcessoDatasetaliadocidadeufSigla.BeforeLoadDFMValues;
  Modulos_AcessoDatasetaliadoparceironome.BeforeLoadDFMValues;
  Modulos_AcessoDatasetdbpath.BeforeLoadDFMValues;
  Modulos_AcessoDatasetinclusao.BeforeLoadDFMValues;
  Modulos_AcessoDatasetalteracao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewModulos_AcessoList';
    Width := 554;
    Height := 388;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 246;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 38;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 187;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado.Nome_Fantasia';
      Title := 'Aliado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado.CNPJ';
      Title := 'Cnpj';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modulo';
      Title := 'M'#243'dulo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ultimo_acesso';
      Title := #218'lt. Acesso';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'funcionario.codigo_interno';
      Title := 'C'#243'd. Func.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'funcionario.nome';
      Title := 'Nome Func.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado.segmento.Nome';
      Title := 'Segmento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado.cidade.Nome';
      Title := 'Cidade';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado.parceiro.nome';
      Title := 'Parceiro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'db.path';
      Title := 'Caminho DB';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 11;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 11;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 235;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 8;
    btnExportarExcel.Top := 275;
    btnExportarExcel.Width := 96;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 11;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    edtCidadeNome.SetParentComponent(Self);
    edtCidadeNome.Name := 'edtCidadeNome';
    edtCidadeNome.Left := 122;
    edtCidadeNome.Top := 277;
    edtCidadeNome.Width := 120;
    edtCidadeNome.Height := 22;
    edtCidadeNome.ChildOrder := 21;
    edtCidadeNome.Enabled := False;
    edtCidadeNome.HeightPercent := 100.000000000000000000;
    edtCidadeNome.WidthPercent := 100.000000000000000000;
    btnPesquisarCidade.SetParentComponent(Self);
    btnPesquisarCidade.Name := 'btnPesquisarCidade';
    btnPesquisarCidade.Left := 243;
    btnPesquisarCidade.Top := 277;
    btnPesquisarCidade.Width := 30;
    btnPesquisarCidade.Height := 22;
    btnPesquisarCidade.ChildOrder := 22;
    btnPesquisarCidade.HeightPercent := 100.000000000000000000;
    btnPesquisarCidade.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarCidade, Self, 'OnClick', 'btnPesquisarCidadeClick');
    edtSegmentoNome.SetParentComponent(Self);
    edtSegmentoNome.Name := 'edtSegmentoNome';
    edtSegmentoNome.Left := 298;
    edtSegmentoNome.Top := 277;
    edtSegmentoNome.Width := 120;
    edtSegmentoNome.Height := 22;
    edtSegmentoNome.ChildOrder := 21;
    edtSegmentoNome.Enabled := False;
    edtSegmentoNome.HeightPercent := 100.000000000000000000;
    edtSegmentoNome.WidthPercent := 100.000000000000000000;
    btnPesquisarSegmento.SetParentComponent(Self);
    btnPesquisarSegmento.Name := 'btnPesquisarSegmento';
    btnPesquisarSegmento.Left := 419;
    btnPesquisarSegmento.Top := 277;
    btnPesquisarSegmento.Width := 30;
    btnPesquisarSegmento.Height := 22;
    btnPesquisarSegmento.ChildOrder := 22;
    btnPesquisarSegmento.HeightPercent := 100.000000000000000000;
    btnPesquisarSegmento.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarSegmento, Self, 'OnClick', 'btnPesquisarSegmentoClick');
    edtParceiroNome.SetParentComponent(Self);
    edtParceiroNome.Name := 'edtParceiroNome';
    edtParceiroNome.Left := 8;
    edtParceiroNome.Top := 306;
    edtParceiroNome.Width := 120;
    edtParceiroNome.Height := 22;
    edtParceiroNome.ChildOrder := 21;
    edtParceiroNome.Enabled := False;
    edtParceiroNome.HeightPercent := 100.000000000000000000;
    edtParceiroNome.WidthPercent := 100.000000000000000000;
    btnPesquisarParceiro.SetParentComponent(Self);
    btnPesquisarParceiro.Name := 'btnPesquisarParceiro';
    btnPesquisarParceiro.Left := 129;
    btnPesquisarParceiro.Top := 306;
    btnPesquisarParceiro.Width := 30;
    btnPesquisarParceiro.Height := 22;
    btnPesquisarParceiro.ChildOrder := 22;
    btnPesquisarParceiro.HeightPercent := 100.000000000000000000;
    btnPesquisarParceiro.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarParceiro, Self, 'OnClick', 'btnPesquisarParceiroClick');
    Modulos_AcessoDataset.SetParentComponent(Self);
    Modulos_AcessoDataset.Name := 'Modulos_AcessoDataset';
    Modulos_AcessoDataset.EntitySetName := 'Modulos_Acesso';
    Modulos_AcessoDataset.Connection := DMConnection.ApiConnection;
    Modulos_AcessoDataset.Left := 72;
    Modulos_AcessoDataset.Top := 88;
    Modulos_AcessoDatasetaliadoNome_Fantasia.SetParentComponent(Modulos_AcessoDataset);
    Modulos_AcessoDatasetaliadoNome_Fantasia.Name := 'Modulos_AcessoDatasetaliadoNome_Fantasia';
    Modulos_AcessoDatasetaliadoNome_Fantasia.FieldName := 'aliado.Nome_Fantasia';
    SetEvent(Modulos_AcessoDatasetaliadoNome_Fantasia, Self, 'OnGetText', 'Modulos_AcessoDatasetaliadoNome_FantasiaGetText');
    Modulos_AcessoDatasetaliadoCNPJ.SetParentComponent(Modulos_AcessoDataset);
    Modulos_AcessoDatasetaliadoCNPJ.Name := 'Modulos_AcessoDatasetaliadoCNPJ';
    Modulos_AcessoDatasetaliadoCNPJ.FieldName := 'aliado.CNPJ';
    SetEvent(Modulos_AcessoDatasetaliadoCNPJ, Self, 'OnGetText', 'Modulos_AcessoDatasetaliadoCNPJGetText');
    Modulos_AcessoDatasetmodulo.SetParentComponent(Modulos_AcessoDataset);
    Modulos_AcessoDatasetmodulo.Name := 'Modulos_AcessoDatasetmodulo';
    Modulos_AcessoDatasetmodulo.FieldName := 'modulo';
    Modulos_AcessoDatasetmodulo.Required := True;
    Modulos_AcessoDatasetmodulo.Size := 255;
    Modulos_AcessoDatasetultimo_acesso.SetParentComponent(Modulos_AcessoDataset);
    Modulos_AcessoDatasetultimo_acesso.Name := 'Modulos_AcessoDatasetultimo_acesso';
    Modulos_AcessoDatasetultimo_acesso.FieldName := 'ultimo_acesso';
    Modulos_AcessoDatasetultimo_acesso.Required := True;
    Modulos_AcessoDatasetultimo_acesso.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Modulos_AcessoDatasetfuncionariocodigo_interno.SetParentComponent(Modulos_AcessoDataset);
    Modulos_AcessoDatasetfuncionariocodigo_interno.Name := 'Modulos_AcessoDatasetfuncionariocodigo_interno';
    Modulos_AcessoDatasetfuncionariocodigo_interno.FieldName := 'funcionario.codigo_interno';
    Modulos_AcessoDatasetfuncionarionome.SetParentComponent(Modulos_AcessoDataset);
    Modulos_AcessoDatasetfuncionarionome.Name := 'Modulos_AcessoDatasetfuncionarionome';
    Modulos_AcessoDatasetfuncionarionome.FieldName := 'funcionario.nome';
    Modulos_AcessoDatasetaliadosegmentoNome.SetParentComponent(Modulos_AcessoDataset);
    Modulos_AcessoDatasetaliadosegmentoNome.Name := 'Modulos_AcessoDatasetaliadosegmentoNome';
    Modulos_AcessoDatasetaliadosegmentoNome.FieldName := 'aliado.segmento.Nome';
    SetEvent(Modulos_AcessoDatasetaliadosegmentoNome, Self, 'OnGetText', 'Modulos_AcessoDatasetaliadosegmentoNomeGetText');
    Modulos_AcessoDatasetaliadocidadeNome.SetParentComponent(Modulos_AcessoDataset);
    Modulos_AcessoDatasetaliadocidadeNome.Name := 'Modulos_AcessoDatasetaliadocidadeNome';
    Modulos_AcessoDatasetaliadocidadeNome.FieldName := 'aliado.cidade.Nome';
    SetEvent(Modulos_AcessoDatasetaliadocidadeNome, Self, 'OnGetText', 'Modulos_AcessoDatasetaliadocidadeNomeGetText');
    Modulos_AcessoDatasetaliadocidadeufSigla.SetParentComponent(Modulos_AcessoDataset);
    Modulos_AcessoDatasetaliadocidadeufSigla.Name := 'Modulos_AcessoDatasetaliadocidadeufSigla';
    Modulos_AcessoDatasetaliadocidadeufSigla.FieldName := 'aliado.cidade.uf.Sigla';
    Modulos_AcessoDatasetaliadoparceironome.SetParentComponent(Modulos_AcessoDataset);
    Modulos_AcessoDatasetaliadoparceironome.Name := 'Modulos_AcessoDatasetaliadoparceironome';
    Modulos_AcessoDatasetaliadoparceironome.FieldName := 'aliado.parceiro.nome';
    Modulos_AcessoDatasetdbpath.SetParentComponent(Modulos_AcessoDataset);
    Modulos_AcessoDatasetdbpath.Name := 'Modulos_AcessoDatasetdbpath';
    Modulos_AcessoDatasetdbpath.FieldName := 'db.path';
    Modulos_AcessoDatasetinclusao.SetParentComponent(Modulos_AcessoDataset);
    Modulos_AcessoDatasetinclusao.Name := 'Modulos_AcessoDatasetinclusao';
    Modulos_AcessoDatasetinclusao.FieldName := 'inclusao';
    Modulos_AcessoDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Modulos_AcessoDatasetalteracao.SetParentComponent(Modulos_AcessoDataset);
    Modulos_AcessoDatasetalteracao.Name := 'Modulos_AcessoDatasetalteracao';
    Modulos_AcessoDatasetalteracao.FieldName := 'alteracao';
    Modulos_AcessoDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Modulos_AcessoDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 144;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 400;
    tmrConsulta.Top := 72;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    edtCidadeNome.AfterLoadDFMValues;
    btnPesquisarCidade.AfterLoadDFMValues;
    edtSegmentoNome.AfterLoadDFMValues;
    btnPesquisarSegmento.AfterLoadDFMValues;
    edtParceiroNome.AfterLoadDFMValues;
    btnPesquisarParceiro.AfterLoadDFMValues;
    Modulos_AcessoDataset.AfterLoadDFMValues;
    Modulos_AcessoDatasetaliadoNome_Fantasia.AfterLoadDFMValues;
    Modulos_AcessoDatasetaliadoCNPJ.AfterLoadDFMValues;
    Modulos_AcessoDatasetmodulo.AfterLoadDFMValues;
    Modulos_AcessoDatasetultimo_acesso.AfterLoadDFMValues;
    Modulos_AcessoDatasetfuncionariocodigo_interno.AfterLoadDFMValues;
    Modulos_AcessoDatasetfuncionarionome.AfterLoadDFMValues;
    Modulos_AcessoDatasetaliadosegmentoNome.AfterLoadDFMValues;
    Modulos_AcessoDatasetaliadocidadeNome.AfterLoadDFMValues;
    Modulos_AcessoDatasetaliadocidadeufSigla.AfterLoadDFMValues;
    Modulos_AcessoDatasetaliadoparceironome.AfterLoadDFMValues;
    Modulos_AcessoDatasetdbpath.AfterLoadDFMValues;
    Modulos_AcessoDatasetinclusao.AfterLoadDFMValues;
    Modulos_AcessoDatasetalteracao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
